import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
import { Grid, Hidden } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import { NAVIGATION_TYPES } from 'Utils/appShell';
import Navigation from 'Containers/navigation/index';
import Routes from 'Router';

const styles = theme => ({
  page: {
    backgroundColor: theme.palette.background.page,
  },
  navigationContainer: {
    width: 96,
    maxWidth: 96,
    backgroundColor: theme.palette.background.navigation,
  },
  layoutGrid: {
    width: '100%',
    height: 'auto',
    minHeight: '100vh',
  },
  layoutGridItem: {
    display: 'flex',
    flexGrow: 1,
  },
});

class PortalRoot extends React.Component {
  render() {
    const { classes } = this.props;

    return (
      <Grid
        container
        direction="row"
        className={classes.layoutGrid}
        spacing={0}
      >
        <Hidden smDown>
          <Grid
            item
            md={1}
            className={classNames(
              classes.layoutGridItem,
              classes.navigationContainer
            )}
          >
            <Navigation variant={NAVIGATION_TYPES.RAIL} />
          </Grid>
        </Hidden>
        <Grid
          item
          md={11}
          sm={12}
          className={classNames(
            classes.layoutGridItem,
            classes.page,
            'fullWidth'
          )}
        >
          <Routes />
        </Grid>
      </Grid>
    );
  }
}

PortalRoot.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

PortalRoot = compose(
  withRouter,
  withStyles(styles, { withTheme: true })
)(PortalRoot);

export default PortalRoot;
